import { MapClusterV2 } from '../movisat/map-cluster-v2';
import { MapLatLng } from './map.latlng';
import { MapPoint } from './map.point';

export abstract class MapMarker {
    public id: number;       // Identificador secuencial
    public dataModel: any;   // Objeto asociado (modelo de negocio)
    public map: any;         // Mapa nativo
    public marker: any;      // Marcador nativo
    public title: string;    // Título que aparece al pasar el cursor
    public label: string;    // Texto que aparece en el centro del marcador
    public content: string;  // Contenido que aparece al pinchar
    public position: MapLatLng;
    public icon: string;
    public zIndex: number;
    public drag: boolean;
    public visible: boolean;
    public minZoom: number;
    public maxZoom: number;
    public clusterV2: MapClusterV2;
    public visibleCluster = false;

    constructor(id: number, title: string, label: string, content: string, position: MapLatLng, icon: string,
        zIndex: number, map: any, drag: boolean, visible: boolean, minZoom: number, maxZoom: number, cluster: any) {
        this.id = id;
        this.map = map;
        this.title = title;
        this.label = label;
        this.content = content;
        this.position = position;
        // Si no se ha especificado icono pongo uno por defecto
        if (icon == null || icon.length < 1) {
            icon = 'assets/images/redmarker.png';
        }
        this.icon = icon;
        this.zIndex = zIndex;
        this.drag = drag;
        this.visible = visible;
        this.minZoom = minZoom;
        this.maxZoom = maxZoom;
        this.clusterV2 = cluster;
        this.visibleCluster = !cluster; // Para los marcadores que no pertenecen a un cluster
    }

    abstract createMarker(): any;
    abstract setTitle(text: string): any;
    abstract setLabel(text: string): any;
    abstract setContent(content: string): any;
    abstract setPosition(position: MapLatLng): any;
    abstract setPositionNotRefreshCluster(position: MapLatLng): any;
    abstract setIcon(icon: string): any;
    abstract setIconEx(icon: string, sizeX: number, sizeY: number, origin: MapPoint, anchor: MapPoint): any;
    abstract setZIndex(zIndex: number): any;
    abstract setVisible(visible: boolean): any;
    abstract setDraggable(drag: boolean): any;
    abstract animate(milisec: number): any;
    abstract setVisibleFromCluster(visible: boolean): any;
    abstract setVisibleCluster(visible: boolean): any;
    abstract hide(): any;

    setData(data: any) {
        this.dataModel = (data !== undefined ? data : null);
    }
}
